import type { Design } from '../types/editor.types';

/* ══════════════════════════════════════════════════════════════════════════
   Generated HTML → a Design the editor can hold.

   The assistant returns finished email HTML (`<table>…`). Both editors in this
   app are block-based — `loadDesign` takes a structured `Design` and there is
   no HTML parser anywhere in the codebase — so the markup cannot be decomposed
   into text/image/button blocks without inventing an importer.

   It does not need to be. The element model already has an `html` type whose
   export is verbatim (`services/export.ts`, `case 'html'` returns `code`), so
   wrapping the markup in one such element gives the editor a real document
   that round-trips byte-for-byte. `exportHtml` returns exactly what the
   assistant sent, and `exportJson` produces the second artifact the save flow
   needs — which is what makes `template_save_request` possible at all.

   The tradeoff, stated plainly: the result is one opaque block, not a
   decomposed layout. It renders and saves correctly, but the visual editor
   cannot pick apart the pieces inside it. That also keeps the markup identical
   to what the model has in `previous_response_id`, so a refinement edits the
   same document the user is looking at.
   ══════════════════════════════════════════════════════════════════════════ */

const uid = (prefix: string) =>
  `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

export function designFromHtml(
  html: string,
  metadata: Design['metadata'] = {},
): Design {
  return {
    id: uid('design'),
    version: '1.0',
    mode: 'email',
    body: {
      rows: [
        {
          id: uid('row'),
          styles: {},
          columns: [
            {
              id: uid('col'),
              width: 100,
              styles: {},
              elements: [
                {
                  id: uid('html'),
                  type: 'html',
                  // `code` is the key `exportHtml` reads for an html element.
                  content: { code: html },
                  styles: {},
                },
              ],
            },
          ],
        },
      ],
      styles: { backgroundColor: '#ffffff', padding: '0px' },
    },
    metadata,
  };
}
